import { useState } from "react";
import styles from "./home-about.module.css";

const SHOW_SLIDER = false;
function HomeAboutSlider() {
  const [aboutImage, setAboutImage] = useState("about.jpg");
  return (
    <div className={styles.aboutImageWrapper}>
      {SHOW_SLIDER && (
        <div
          className={styles.arrowLeft}
          onClick={() =>
            aboutImage === "about4.jpg"
              ? setAboutImage("about5.jpg")
              : aboutImage === "about5.jpg"
              ? setAboutImage("about6.jpg")
              : setAboutImage("about.jpg")
          }
        >
          <i className="fa fa-arrow-left" />
        </div>
      )}
      {SHOW_SLIDER && (
        <div
          className={styles.arrowRight}
          onClick={() =>
            aboutImage === "about4.jpg"
              ? setAboutImage("about6.jpg")
              : aboutImage === "about5.jpg"
              ? setAboutImage("about4.jpg")
              : setAboutImage("about.jpg")
          }
        >
          <i className="fa fa-arrow-right" />
        </div>
      )}
      <div className={styles.squareOne} />
      <div className={styles.squareTwo} />
      <div className={styles.aboutImage}>
        <img src={"/assets/image/" + aboutImage} alt={"درباره شرکت"} />
      </div>
    </div>
  );
}

export default HomeAboutSlider;
